import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { assign, forEach } from 'lodash';

@Component({
  selector: 'app-edit-seeder-group-metrics',
  templateUrl: './edit-seeder-group-metrics.component.html',
  styleUrls: ['./edit-seeder-group-metrics.component.scss']
})
export class EditSeederGroupMetricsComponent implements OnInit {

    private _groupData: any;

    metrics: any[];
    saveActionIsEnabled = false;

    constructor(
        private _dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngOnInit() {

        // Init food config initial value
        this._groupData = assign({}, this.data);

        this.metrics = [{
            label: 'Conversiones',
            node: 'conversions',
            value: this._groupData.conversions
        }, {
            label: 'Dicipulados',
            node: 'discipled',
            value: this._groupData.discipled
        }, {
            label: 'Bautizos',
            node: 'baptism',
            value: this._groupData.baptism
        }, {
            label: 'Lideres en Formación',
            node: 'leaders',
            value: this._groupData.leaders
        }, {
            label: 'Grupos Pequeños',
            node: 'small_groups',
            value: this._groupData.small_groups
        }, {
            label: 'Asistentes en Grupo',
            node: 'weekly_attendees',
            value: this._groupData.weekly_attendees
        }];

    }

    onSaveGroup() {

        forEach(this.metrics, metric => {

            this._groupData[metric.node] = metric.value;

        });

        this._dialogRef.close(this._groupData);

    }

    onCancel() {

        this._dialogRef.close();

    }

    changeGroupMetric(metric: any, up = true): void {

        this.saveActionIsEnabled = true;

        if (up) {

            metric.value++;

        } else {

            metric.value--;

        }

    }

}



// WEBPACK FOOTER //
// ./src/app/components/modals/edit-seeder-group-metrics/edit-seeder-group-metrics.component.ts